import React, { FC } from 'react';

import { useDataAttributes } from '@lumapps/data-attributes';
import { robotSparkle } from '@lumapps/lumx/custom-icons';
import { Emphasis, IconButton, IconButtonProps, Size } from '@lumapps/lumx/react';
import { useLinkProps } from '@lumapps/router';
import { useTranslate } from '@lumapps/translations';

import { SCOPE } from '../../constants';
import { AGENT_LIBRARY } from '../../keys';
import { agentLibraryRoute } from '../../routes';

export interface AgentLibraryMenuProps {
    /** custom styles passed down to the agent library icon */
    styles?: Record<string, any>;
}

export const AgentLibraryMenu: FC<AgentLibraryMenuProps> = ({ styles }) => {
    const linkProps = useLinkProps({ route: agentLibraryRoute });
    const { translateKey } = useTranslate();
    const { get } = useDataAttributes(SCOPE);

    return (
        <IconButton
            emphasis={Emphasis.low}
            icon={robotSparkle}
            label={translateKey(AGENT_LIBRARY.AGENT_LIBRARY)}
            size={Size.m}
            color={styles?.themeColor}
            {...linkProps}
            target={linkProps.target as IconButtonProps['target']}
            {...get({ element: 'header-icon', action: 'open-agent-library-page' })}
        />
    );
};
